import React, {useState} from 'react';
import {FloatButton} from "antd";
import classes from './lan.module.css';
import ru_flag from '../../../images/lanFlags/ru_flag_icon.png';
import kz_flag from '../../../images/lanFlags/kaz_glag_icon.png';
import en_flag from '../../../images/lanFlags/eng_flag_icon.png';
import i18n from "i18next";

const LanguageButton = () => {
    const [selectedLan, setSelectedLan] = useState({
        value: localStorage.getItem('lan'),
        label: localStorage.getItem('lan')
    });

    const [open, setOpen] = useState(false);

    // const kz = {
    //     value: "ҚАЗ",
    //     label: "ҚАЗ",
    //     ii8n: "kk"
    // }

    const ru = {
        value: "РУС",
        label: "РУС",
        ii8n: "ru"
    }

    const en = {
        value: "ENG",
        label: "ENG",
        ii8n: "en"
    }

    const changeLang = (selectedLang) => {
        localStorage.setItem('lan', selectedLang.value);
        setSelectedLan(selectedLang);
        i18n.changeLanguage(selectedLang.ii8n);
        setOpen(false);
    }

    const selectedIconLan = selectedLan.value === 'РУС' ? <span style={{fontSize: 14}}>РУ</span> : selectedLan.value === 'ENG' ? <span style={{fontSize: 14}}>EN</span> : <span style={{fontSize: 14}}>РУ</span>

    return (
        <FloatButton.Group
            trigger="click"
            style={{
                right: 50,
                bottom: 110,
                fontSize: 14
            }}
            icon={selectedIconLan}
            open={open}
            onClick={() => {
                setOpen(!open);
            }}
        >
            {/*<FloatButton onClick={() => {changeLang(eng)}} icon={<FlagIcon icon={eng_flag}/>}/>*/}
            <FloatButton onClick={() => {changeLang(ru)}} icon={<span style={{fontSize: 14}}>РУ</span>}/>
            {/*<FloatButton onClick={() => {changeLang(kz)}} icon={<FlagIcon icon={kz_flag}/>}/>*/}
            <FloatButton onClick={() => {changeLang(en)}} icon={<span style={{fontSize: 14}}>EN</span>}/>
        </FloatButton.Group>
    );
};

export default LanguageButton;

const FlagIcon = ({icon}) => {
    return (
        <div className={classes.iconFlagBlock}>
            <img src={icon} alt=""/>
        </div>
    );
};